export default __webpack_public_path__ + "static/media/university.0ccb7cd1.svg";